<template>
  <div class="btm">
    <!-- <Row class="rows">
      <Col span='6'>在线人数：{{lineObj.online}}</Col>
      <Col span='8'>版权归{{lineObj.company_name}}所有</Col>
      <Col span='10'><a @click="$router.push({name:'StatisticalLearning'})">帮助中心 联系我们 关于我们</a></Col>
    </Row> -->
  </div>
</template>

<script>
import "./btm.less";
export default {
  name: "Btm",
  data() {
    return {
      lineObj:{}
    }
  },
  mounted(){
    this.getline()
  },
  methods: {
    getline(){
       this.$axios
        .post('/app/auth/getWebInfo')
        .then((res) => {
          if (res.code == 1) {
            this.lineObj=res.data
          } else {
            this.$Message.error(res.msg);
          }
        });
    }
  }
};
</script>
<style  scoped lang='less'>
.btm{
  width: 100%;
  padding:6px 10%;
  font-size:.9rem;
  color:#777;
  height: 100%;
  .rows{
    display: flex;
    div{
      text-align: center;
      a{
        color:#777;
      }
    }
  }
}
</style>